import { type FC } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Footer from './components/Footer';
import Header from './components/Header';

import EmailPreview from './pages/EmailPreview';
import Form from './pages/Form';
import Home from './pages/Home';
import Results from './pages/Results';

const App: FC = () => {
  return (
    <>
      <Header />
      <div className="min-h-[calc(100vh-144px)] p-10 text-gray1 md:mx-10 lg:mx-20">
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/test" element={<Form />} />
            <Route path="/results" element={<Results />} />
            <Route path="/email-preview" element={<EmailPreview />} />
          </Routes>
        </Router>
      </div>
      <Footer />
    </>
  );
};

export default App;
